import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  PatternlibMainNavigationItem,
  PatternlibContactItem,
  PatternlibContact,
  PatternlibTextlink,
} from "@liebherr/patternlib-react";
import styles from "./Contact.module.css";
import MainNavigation from "../../components/main-navigation/MainNavigation";
import Sidebar from "../../components/sidebar/Sidebar";
import { useTranslation } from "react-i18next";
import weckwerth from "../../img/weckwerth_img_310.jpg";
import heinz from "../../img/heinz_img_310.jpg";
import useMutationObserver from "../../hooks/useMutationObserver";
import { pushToDataLayer } from "../../helpers/helpers";

const Contact = ({ profile, isDemoUser }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const navigate = useNavigate();

  // use mutation observer to get current screen size
  const options = {
    config: { attributes: true, childList: true, subtree: true },
  };
  const target = document.documentElement;
  const attributeName = "breakpoint";
  const screen = useMutationObserver(options, target, attributeName);

  const toPage = (tabId) => () => {
    switch (tabId) {
      case 0:
        navigate("/myconfigs");
        break;
      case 1:
        navigate("/contact");
        break;
      default:
        navigate("/");
    }
  };

  const contactMailGA = (eMail) => {
    const eventName = "contact_mail";
    const pagePath = location.pathname;
    const pageType = "contact";
    const language =
      i18n.language === "de-DE" || i18n.language === "de" ? "de-DE" : "en-EN";
    const e_mail = eMail;
    let props = { pagePath, pageType, language, e_mail };
    pushToDataLayer(eventName, props);
  };

  return (
    <>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.navigation}>
            <MainNavigation
              activeTab={1}
              profile={profile}
              isDemoUser={isDemoUser}
            ></MainNavigation>
          </div>
        </header>
        <div className={styles.body}>
          <div className={styles.sidebar}>
            <div className={styles.sidebarWrapper}>
              {screen === "isMobile" ? (
                <>
                  <PatternlibMainNavigationItem onClick={toPage(0)}>
                    {t("Sidebar.myConfigs")}
                  </PatternlibMainNavigationItem>
                  <PatternlibMainNavigationItem is-active onClick={toPage(1)}>
                    {t("Sidebar.contact")}
                  </PatternlibMainNavigationItem>
                </>
              ) : (
                <Sidebar activeTab={1}></Sidebar>
              )}
            </div>
          </div>
          <div className={styles.personaldata}>
            <div className={styles.dataheader}>
              <h2>{t("contact.contact")}</h2>
            </div>
            <div
              className={`${styles.contact} ${
                isDemoUser && styles.reducePadding
              }`}
            >
              <div className={styles.datacontent}>
                <div className={styles.contentname}>
                  <img className={styles.avatar} src={heinz}></img>
                  <h3 className={styles.contentheader}>{t("contact.heinz")}</h3>
                </div>
                <PatternlibContact>
                  <PatternlibContactItem
                    type="phone"
                    value="+49 (7354) 80 7450"
                    icon="business-cell-phones"
                  ></PatternlibContactItem>
                  <PatternlibContactItem
                    type="email"
                    value="michaelmartin.heinz@liebherr.com"
                    icon="envelope"
                    onClick={() =>
                      contactMailGA("michaelmartin.heinz@liebherr.com")
                    }
                  ></PatternlibContactItem>
                  <PatternlibContactItem
                    type="address"
                    value='{"zip_code": "88457", "city": "Kirchdorf an der Iller / Oberopfingen", "street": "St. Vitus 5 ", "country_iso": "DE", "country": "Germany"}'
                    icon="map-location"
                  ></PatternlibContactItem>
                </PatternlibContact>
              </div>
            </div>
            <div className={styles.link}>
              <PatternlibTextlink
                label={t("contact.website")}
                uppercase="false"
                icon-position="left"
                href={t("contact.url")}
              ></PatternlibTextlink>
            </div>
            <div className={styles.personaldata2}>
              <div className={styles.offer}>
                <p className={styles.offertext}>
                  {t("NotRightProductDiv.offer")}
                </p>
                <PatternlibTextlink
                  label={t("contact.websiteContact")}
                  uppercase="false"
                  icon-position="left"
                  href={t("contact.contactUrl")}
                ></PatternlibTextlink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
